import { render, staticRenderFns } from "./noticeMsg.vue?vue&type=template&id=32cca56a"
import script from "./noticeMsg.vue?vue&type=script&lang=js"
export * from "./noticeMsg.vue?vue&type=script&lang=js"
import style0 from "./noticeMsg.vue?vue&type=style&index=0&id=32cca56a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports